import { Log } from '@/parsing/Log';
import { LogEntryType } from '@/parsing/LogEntry';

import { TimelineMarker, TimelineRow, TimelineRowGroup } from '../../TimelineData';
import { obtainFreeRowForMarker } from '../obtainFreeRowForMarker';
import { TimelineGeneratorContext } from '../TimelineGeneratorContext';

export function generateAndroidAnalyticsGroupFromLog(
  log: Log,
  ctx: TimelineGeneratorContext,
): TimelineRowGroup {
  const screenRows: TimelineRow[] = [];
  const eventRows: TimelineRow[] = [];

  for (const entry of log.entries) {
    if (entry.entryType !== LogEntryType.Generic) {
      continue;
    }
    if (entry.extra.generic?.module !== 'Core.Analytics') {
      continue;
    }

    let tooltipContent = entry.content;
    let textOnMarker = '';
    tooltipContent = tooltipContent.split('with params =')[0];
    const tooltipMatch = tooltipContent.match(/\[.*]/);
    if (tooltipMatch && tooltipMatch[0]) {
      textOnMarker = tooltipMatch[0].replaceAll('[', '').replaceAll(']', '');
    }

    const isScreen = tooltipContent.startsWith('Sending screen event');
    const isBugReportScreen =
      textOnMarker === 'Bug Report Shown' || textOnMarker === 'Bug Report Button Tap';
    const marker: TimelineMarker = {
      markerId: ctx.nextMarkerId,
      logEntry: entry,
      startTimeMs: entry.date.getTime(),
      endTimeMs: undefined,
      fillColor: isBugReportScreen ? '#cf0202' : isScreen ? '#aaaaff' : '#cccc99',
      textOnMarker,
      textOnMarkerColor: isBugReportScreen ? '#820101' : isScreen ? '#333388' : '#888833',
      tooltipContent,
    };
    ctx.nextMarkerId += 1;

    const row = obtainFreeRowForMarker(isScreen ? screenRows : eventRows, marker);
    row.markers.push(marker);
  }

  return {
    name: 'Analytics',
    rows: screenRows.concat(eventRows),
    expanded: true,
  };
}
